// removed by extract-text-webpack-plugin
module.exports = {"zoomTableLegacyWrapper":"zoom-table-legacy-wrapper--3dJin","handoverPendingCnWiseWrapper":"handover-pending-cn-wise-wrapper--CT0bc","reactTable":"ReactTable--3HxjL","rtTable":"rt-table--37QyH","rtThead":"rt-thead--Gt_X3"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commons/zoomTable/zoomTable.scss
// module id = JcF4
// module chunks = 1